import { render, staticRenderFns } from "./affiliateItems.vue?vue&type=template&id=260689f4&scoped=true"
import script from "./affiliateItems.vue?vue&type=script&lang=js"
export * from "./affiliateItems.vue?vue&type=script&lang=js"
import style0 from "./affiliateItems.vue?vue&type=style&index=0&id=260689f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_cache-loader@4.1.0_webpac_6f95da160c08ac8dc5724deda4dd3901/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260689f4",
  null
  
)

export default component.exports